import { Divider, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/HomeRounded";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { loadRoutes } from "../actions/loadRoutes";
import { IP } from "../config/IP";
import DocDetails from "./DocDetails";
const useStyles = makeStyles((theme) => ({
	root: {
		margin: theme.spacing(1),
		padding: 5,
		justifyContent: "center",
	},
}));

const DocDetailPage = (props) => {
	let { DocId } = useParams();
	const dispatch = useDispatch();
	const classes = useStyles();
	const state = useSelector((state) => state);

	useEffect(() => {
		if (!state.loadRoutes.isLaoded) {
			let inputs = {
				url: IP.nodeServer + "api/routesRules",
				method: "POST",
				data: [{ name: "Doc_type_id", value: 1 }],
			};

			dispatch(loadRoutes(inputs));
		}
		
	}, []);

	if (!state.companyData.isSaved || !state.loadRoutes.isLaoded) {
		return (
			<div className={classes.root}>
				<div>Loading....</div>
			</div>
		);
	}
	return (
		<div className={classes.root}>
			<Paper variant="outlined">
				<Link to="/">
					<HomeIcon />
				</Link>
				<Divider />
				<Typography variant="h5">DocDetailsPage </Typography>
				<Divider />

				<DocDetails DocId={DocId} />
			</Paper>
		</div>
	);
};

export default DocDetailPage;
